import React from "react"
import ReturningStudentsTable from "./application-table"

export default function ReturningStudents() {
  return (
    <div>
      <ReturningStudentsTable />
    </div>
  )
}
